import * as React from 'react';
import { SVGProps } from 'react';

const SvgDoctorNote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7803_2530)">
      <path
        fill="currentColor"
        d="m15.803 30.094-.901 1.593h-1.39l1.593-2.65-1.48-2.48h1.347l.857 1.487.863-1.488h1.359l-1.517 2.513 1.58 2.612h-1.41l-.888-1.594-.013.007ZM26.178 10.65H13.619v2.05h12.559v-2.05Zm0 4.106H13.619v2.05h12.559v-2.05Zm0 4.1H13.619v2.05h12.559v-2.05Zm-4.184 4.106h-8.375v2.05h8.375v-2.05Zm4.19 5.138h-6.292v2.05h6.292V28.1Z"
      />
      <path
        fill="currentColor"
        d="M28.286 6.606H26.19v1.875h2.095c.05 0 .095.038.095.088v25.125c0 .05-.044.087-.095.087H11.524c-.05 0-.095-.037-.095-.087V8.569c0-.05.044-.088.095-.088h2.102l1.917-1.875h-4.02c-1.104 0-2 .881-2 1.963v25.125c0 1.081.896 1.962 2 1.962h16.77c1.104 0 2-.881 2-1.962V8.569c0-1.082-.896-1.963-2-1.963h-.007Z"
      />
      <path
        fill={props.fill}
        d="M26.19 8.481V4.394l-8.374-.019-4.197 4.106h12.572Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_7803_2530">
        <path
          fill="#fff"
          d="M0 0h20.762v31.281H0z"
          transform="translate(9.524 4.375)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgDoctorNote;
